import { foldCode } from '@codemirror/language';
import { EditorSelection } from '@codemirror/state';
import { EditorView } from '@codemirror/view';

import { isDev } from '../../../core/utils/is-node-environment.js';

/**
 * Moves the cursor to each folding section, and call foldCode on the view.
 * @param foldings - array of folding positions
 * @param editorView - Editor view
 */
export function runFoldings(foldings: number[], editorView: EditorView): void {
  const selection = editorView.state.selection;

  for (const foldPosition of foldings) {
    if (editorView.state.doc.length <= foldPosition) {
      if (isDev()) {
        // eslint-disable-next-line no-console
        console.warn(
          `Editor folding position [${foldPosition}] exceeds text length [${editorView.state.doc.length}]. Folding will be ignored.`,
        );
      }
      continue;
    }
    const transaction = editorView.state.update({
      selection: EditorSelection.cursor(foldPosition),
    });
    if (transaction) {
      editorView.dispatch(transaction);
    }
    foldCode(editorView);
  }

  const resetCursorTransaction = editorView.state.update({ selection });
  editorView.dispatch(resetCursorTransaction);
}
